import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import {ToolsReflexionsverhaltenComponent} from './tools-reflexionsverhalten/tools-reflexionsverhalten.component';


const routes: Routes = [
  { path: '', redirectTo: 'tools-reflexionsverhalten', pathMatch: 'full' },
  { path: 'tools-reflexionsverhalten', component: ToolsReflexionsverhaltenComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// C:/Users/m.altmann/Documents/Projekte/telegärtner/tg-pwa/src/app/app-routing.module.ts